import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { UpdateFormPage } from "@/pages/dashboard/updates/form";

export const Route = createFileRoute("/_main/dashboard/updates/$id/edit")({
  component: () => (
    <RequirePermission action="updates.write">
      <UpdateFormPage />
    </RequirePermission>
  ),
});
